import {
	Component,
	ViewEncapsulation,
	OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { Organization } from "../../../models/organization";
import { ApiService } from "../../../lib/api.service";
import { LogService } from "../../../lib/log.service";
import { ModalService } from "../../../lib/modal.service";

@Component({
    selector: "organization-clone",
    templateUrl: "./organization-clone.component.html",
    styleUrls: ["./organization-clone.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrganizationCloneComponent implements OnInit {
	organizations: Organization[];
	isLoaded: boolean = false;
	sourceOrgID: number;
	errors: string = '';
	submitButtonPressed: boolean = false;

	constructor(
		private api: ApiService,
		private log: LogService,
		private modalService: ModalService,
		private router: Router,
		private location: Location
	) {}

	ngOnInit() {
		this.api.get("admin/organizations", { Active: true }).subscribe(
			(results: any) => {
				this.organizations = Organization.initializeArray(results.data);
				this.isLoaded = true;
			},
			(error: any) => {
				this.log.error("Error loading. " + error.message);
			}
		);
	}

	doSave() {
		this.submitButtonPressed = true;
		this.errors = '';

		if (!this.sourceOrgID) {
			this.errors = "Please select a source organization.";
			return;
		}

		this.api
			.post(
				`organizations/clone`,
				{orgId: this.sourceOrgID},
				true,
				false
			)
			.subscribe(
				(data: any) => {
					this.modalService.showAlert(
						"Success",
						"Organization resources have been cloned."
					);
					this.router.navigate(['/admin/organization-listing']);
				},
				(error: any) => {
					this.modalService.showAlert(
						"Error",
						"Something went wrong. " + error.message
					);
				}
			);
	}

	onClose() {
		this.location.back();
	}
}
